import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const AddToCart = createAsyncThunk(
  "product/AddToCart",
  async (cartData, thunkAPI) => {
    try {
      let storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("authToken");
      let requestBody = {
        quantity: cartData?.quantity,
        size: cartData?.size,
        sessionId: storedUuid ? storedUuid : "",
      };

      if (cartData?.variationsId) {
        requestBody.variation = {
          variationId: cartData.variationsId,
        };
      } else {
        requestBody.productId = cartData.productId;
      }
      const response = await axios.post(endPoint.ADDTOCART, requestBody, {
        headers: {
          Authorization: Token ? `Bearer ${Token}` : "",
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

const AddToCartSlice = createSlice({
  name: "AllData",
  initialState: {
    AllData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddToCart.fulfilled, (state, action) => {
        state.AllData = action.payload;
      })
      .addCase(AddToCart.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default AddToCartSlice.reducer;
